import {createRouter, createWebHistory} from 'vue-router'
import AppLayout from '@/App'
import BasicLayout from '@/layouts/basic-layout/BasicLayout'

const routes = [
    {
        path: '/',
        component: BasicLayout,
        redirect:'/index',
        children: [
            {
                path: '/index',
                name: 'index',
                component: () => import("@/views/index/index/Index")
            }
        ]
    },
    {
        path: '/user',
        redirect:'/user/login',
        component: AppLayout,
        children: [
            {
                path: '/user/login',
                name: 'login',
                component: () => import("@/views/user/login/Login")
            }
        ]
    },
    {
        path: '/fee-enquiry',
        component: BasicLayout,
        redirect:'/fee-enquiry/index',
        children: [
            {
                path: '/fee-enquiry/index',
                name: 'fee-enquiry-index',
                component: () => import("@/views/fee-enquiry/index/Index")
            },
            {
                path: '/fee-enquiry/payfee',
                name: 'payfee',
                component: () => import("@/views/fee-enquiry/payfee/Payfee")
            },
            {
                path: '/fee-enquiry/water-bill',
                name: 'water-bill',
                component: () => import("@/views/fee-enquiry/water-bill/WaterBill")
            },
            {
                path: '/fee-enquiry/invoice-manage',
                name: 'invoice-manage',
                component: () => import("@/views/fee-enquiry/invoice-manage/InvoiceManage")
            },
        ]
    },
    {
        path: '/meter-manage',
        component: BasicLayout,
        redirect:'/meter-manage/index',
        children: [
            {
                path: '/meter-manage/index',
                name: 'meter-manage-index',
                component:  () => import("@/views/meter-manage/index/Index")
            },
            {
                path: '/meter-manage/self-report-degree',
                name: 'self-report-degree',
                component: () => import("@/views/meter-manage/self-report-degree/SelfReportDegree")
            },
            {
                path: '/meter-manage/change-meter',
                name: 'change-meter',
                component: () => import("@/views/meter-manage/change-meter/ChangeMeter")
            },
            {
                path: '/meter-manage/lose-meter',
                name: 'lose-meter',
                component: () => import("@/views/meter-manage/lose-meter/LoseMeter")
            },
            {
                path: '/meter-manage/move-meter',
                name: 'move-meter',
                component: () => import("@/views/meter-manage/move-meter/MoveMeter")
            },
            {
                path: '/meter-manage/check-meter',
                name: 'check-meter',
                component: () => import("@/views/meter-manage/check-meter/CheckMeter")
            },
        ]
    },
    {
        path: '/business-hand',
        component: BasicLayout,
        redirect:'/business-hand/index',
        children: [
            {
                path: '/business-hand/index',
                name: 'business-hand-index',
                component: () => import("@/views/business-hand/index/Index")
            },
            {
                path: '/business-hand/reservation',
                name: 'reservation',
                component: () => import("@/views/business-hand/reservation/Reservation")
            },
            {
                path: '/business-hand/transfer-apply',
                name: 'transfer-apply',
                component: () => import("@/views/business-hand/transfer-apply/TransferApply")
            },
            {
                path: '/business-hand/low-income-families',
                name: 'low-income-families',
                component: () => import("@/views/business-hand/low-income-families/LowIncomeFamilies")
            },
            {
                path: '/business-hand/preferential-price',
                name: 'preferential-price',
                component: () => import("@/views/business-hand/preferential-price/PreferentialPrice")
            },
            {
                path: '/business-hand/meter-multi-category',
                name: 'meter-multi-category',
                component: () => import("@/views/business-hand/meter-multi-category/MeterMultiCategory")
            },
            {
                path: '/business-hand/bank-deduct',
                name: 'bank-deduct',
                component: () => import("@/views/business-hand/bank-deduct/BankDeduct")
            },
            {
                path: '/business-hand/step-population-declare',
                name: 'step-population-declare',
                component: () => import("@/views/business-hand/step-population-declare/StepPopulationDeclare")
            },
            {
                path: '/business-hand/category-change',
                name: 'category-change',
                component: () => import("@/views/business-hand/category-change/CategoryChange")
            },
            {
                path: '/business-hand/address-change',
                name: 'address-change',
                component: () => import("@/views/business-hand/address-change/AddressChange")
            },
            {
                path: '/business-hand/suspension-water',
                name: 'suspension-water',
                component: () => import("@/views/business-hand/suspension-water/SuspensionWater")
            },
            {
                path: '/business-hand/restore-water',
                name: 'restore-water',
                component: () => import("@/views/business-hand/restore-water/RestoreWater")
            },
            {
                path: '/business-hand/reservation-service',
                name: 'reservation-service',
                component: () => import("@/views/business-hand/reservation-service/ReservationService")
            },
        ]
    },
    {
        path: '/problem-feedback',
        component: BasicLayout,
        redirect:'/problem-feedback/index',
        children: [
            {
                path: '/problem-feedback/index',
                name: 'problem-feedback-index',
                component: () => import("@/views/problem-feedback/index/Index")
            },
            {
                path: '/problem-feedback/report-repairs',
                name: 'report-repairs',
                component: () => import("@/views/problem-feedback/report-repairs/ReportRepairs")
            }
        ]
    },
    {
        path: '/personal-center',
        component: BasicLayout,
        children: [
            {
                path: '/personal-center/user-bind',
                name: 'user-bind',
                component: () => import("@/views/personal-center/user-bind/UserBind")
            }
        ]
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
